import { BaseEntity } from './base-entity';
import { Issue } from './issue.model';
import { TimeTableFixed } from './time-table-fixed.model';

export class QueueCreateRequest implements BaseEntity {

    constructor(public id?: number,
                public name?: string,
                public description?: string,
                public logoContentType?: string,
                public logo?: any,
                public labelPrefix?: string,
                public infoToPrint?: string,
                public futureVisitPlanningEnabled?: boolean,
                public normalRegistrationEnabled?: boolean,
                public registrationInterval?: number,
                public registrationConfirmPeriod?: number,
                public timeTablesFixed?: Array<TimeTableFixed>,
                public issues?: Array<Issue>,
                public category?: boolean,
                public parentId?: number,
                public facultyId?: number) {

        if (!this.category) {
            this.category = true;
        }
        if (!this.futureVisitPlanningEnabled) {
            this.futureVisitPlanningEnabled = true;
        }
        if (!this.normalRegistrationEnabled) {
            this.normalRegistrationEnabled = true;
        }

        // TODO: use it later
        // if (!this.timeTableFixedList) {
        //     this.timeTableFixedList = [];
        // }
        // if (!this.issues) {
        //     this.issues = [];
        // }
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/models/queue-create-request.model.ts